(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-selfExplain-modal
  (:require ["react-virtualized" :as rv]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.code :refer [code]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]              ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]))





(defn reject-form [!st document]
  (let [!rejectMessage (r/cursor !st [:userDocument-rejectMessage])]
    [mui/grid {:container  true
               :direction  "row"
               :justify    "space-between"
               :spacing    2
               :multiline  true
               :rowsMin    3
               :style      {:paddingRight "5px"}
               :alignItems "flex-start"}
     [mui/grid {:container false :item true :xs 12}
      "Ablehnung Begründung"]
     [mui/grid {:container false :item true :xs 12}
      [mui/text-field {
                       ;:style {:background-color (if (not= (:userDocument-validTo @!st) (:lrClearance-end wop-clearance))  "#ffd6d2" "#ffffff")}
                       :fullWidth       true
                       :type            "text"
                       :helper-text     (if (= "" @!rejectMessage) "Bitte Begründung eingeben" "")
                       :onChange        (fn [e] (swap! !st assoc :userDocument-rejectMessage (h/event-value e)))
                       :label           (str " ")
                       :defaultValue    (str "" (:userDocument-rejectMessage @!st))
                       :InputLabelProps {:disableAnimation true :shrink true}
                       }]
      ]
     ]
    ))



(defn modal [!actual-user {:keys [userDocument-fileName userDocument-path uploaded userDocument-isSelfExplain userDocument-rejected userDocument-rejectMessage] :as document} !show & [!show-doc-assign-modal]]
  (let [!invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !st (r/atom {:reject userDocument-rejected :userDocument-rejectMessage userDocument-rejectMessage})
        !reject (r/cursor !st [:reject])
        active-clearance (d-user/get-active-clearance @!actual-user)
        is-cleared? (d-lrClearance/is-cleared active-clearance)
        !rejectMessage (r/cursor !st [:userDocument-rejectMessage])
        {:keys [user-uuid user-lastName user-firstName]} @!actual-user]
    (fn []
      (log/debug "actual-user-clearance" (clj->js active-clearance))
      [mui/modal
       {:className        "selfexplain-modal"
        :data-clearance   active-clearance
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show false)

        }

       [:div
        {
         :class "modal"
         :style {:width 750}}
        [mui/grid {:container  true
                   :direction  "row"
                   :justify    "space-between"
                   :space      3
                   :alignItems "flex-start"}
         [mui/grid {:container false :item true :xs 12}
          (js/console.log "render selfExplain modal-by-tomId " @!show)
          [:h2 "Dokument als Selbsterklärung bestätigen!"]]

         [mui/grid {:container false :item true :xs 6}
          [:div
           [mui/typography {:style {:wordBreak "break-all"}} "Filename" [:br] (or userDocument-fileName userDocument-path)]
           [:br]
           [mui/typography {:gutterBottom true}
            (if uploaded (str "hochgeladen am: "
                              (subs uploaded 6 8) "." (subs uploaded 4 6) "." (subs uploaded 0 4) " " (subs uploaded 9 10) ":" (subs uploaded 11 13)
                              ) "")]

           (if @!reject
             [reject-form !st document]
             [mui/typography {} "Bitte überprüfe:"
              [:br] "Name: " [:span {:style {:color "blue"}} "`" user-lastName ", " user-firstName "`"]
              [:br] "Es wurde die aktuelle"
              [:br] "Selbsterklärungsvorlage verwendet?"
              [:br] "Eine Unterschrift ist vorhanden?"
              [:br]
              [:br]
              ]
             )
           ]]

         [mui/grid {:container false :item true :xs 6}
          [:f> backend-file/download-wrapper userDocument-path
           (fn [url]
             (let [url (when url (js/URL. url))]
               (when url
                 (.set (.-searchParams url) "inline" "true"))
               [:a {:title "Klick um in neuem Tab zu öffnen"
                    :href  url :target "_blank"}
                [:div {:style {:position "relative" :float "right"}} "Anlage öffnen"] [:br]
                [backend-file/img {:hash     userDocument-path
                                   :preview? true
                                   :style    {:position "relative" :float "right" :maxWidth "400px" :maxHeight "600px" :objectFit "contain" :paddingBottom "10px"} :alt "Ansicht"}]
                ]))]


          [:br]
          [:br]
          ]



         (when (and !show-doc-assign-modal (not is-cleared?))
           [mui/grid {:container false :item true :xs 12}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [code])
              :style     {:marginBottom 10}
              :onClick   (fn []
                           (reset! !show-doc-assign-modal {:showTomId @!show :type :selfExplain})
                           (reset! !show nil))
              }
             "Dokument wählen"]])

         [mui/grid {:container false :item true :xs 4}
          [mui/button
           {:variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   #(reset! !show nil)
            }
           "Abbrechen"]]

         (cond


           ; is rejected
           (and userDocument-rejected (or (= "" @!rejectMessage) (= userDocument-rejectMessage @!rejectMessage)))
           [mui/grid {:container false :item true :xs 6}
            [mui/button
             {:color     "secondary"
              :style     {:float "right"}
              :variant   "contained"
              :startIcon (r/as-element [cancel])
              :onClick   (fn []
                           (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                             {:userDocument-readonly      false
                                                              :userDocument-rejectMessage ""
                                                              :userDocument-rejected      false
                                                              }
                                                             (fn []
                                                               (d-user/>user-edit-field user-uuid {:user-lrWaiting true}
                                                                                        (fn []
                                                                                          (d-user/actual-user-invalidate !actual-user)
                                                                                          (reset! !invalidated true)
                                                                                          )))
                                                             ))
              }
             "Ablehnung zurücknehmen"]]

           ; rejection process
           @!reject
           [mui/grid {:container false :item true :xs 8}
            [mui/button
             {:variant "contained"
              :style   {:marginRight 50}
              :onClick #(reset! !reject true)
              }
             "Nicht ablehnen"]

            (when (or (nil? @!rejectMessage) (= @!rejectMessage ""))
              [mui/chip {:color "primary" :label (str "Bitte Begründung angeben")}])

            (when (not (or (= "" @!rejectMessage) (= userDocument-rejectMessage @!rejectMessage)))
              [mui/button
               {:color     "primary"
                :style     {:float "right"}
                :variant   "contained"
                :startIcon (r/as-element [cancel])
                :onClick   (fn []
                             (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                               {:userDocument-readonly      false
                                                                :userDocument-rejectMessage (:userDocument-rejectMessage @!st)
                                                                :userDocument-rejected      true
                                                                :userDocument-locked        false
                                                                :userDocument-isIdentity    false
                                                                :userDocument-isSelfExplain false
                                                                :userDocument-isTraining    false
                                                                }
                                                               (fn []
                                                                 (d-user/>user-edit-field user-uuid {:user-lrWaiting true}
                                                                                          (fn []
                                                                                            (d-user/actual-user-invalidate !actual-user)
                                                                                            (reset! !invalidated true)
                                                                                            (reset! !show nil)
                                                                                            )))
                                                               ))
                }
               "Ablehnen"])
            ]


           (:userDocument-uuid document)

           [mui/grid {:container false :item true :xs 6}

            [mui/button
             {:color     "secondary"
              :variant   "contained"
              :startIcon (r/as-element [cancel])
              :style     {:marginRight 50}
              :onClick   #(reset! !reject true)
              }
             "Ablehnen"]

            [mui/button
             {:color     "primary"
              :style     {:float "right"}
              :variant   "contained"
              :startIcon (r/as-element [check])
              :onClick   (fn []
                           (d-user/>user-edit-document-field (:userDocument-uuid document)
                                                             {:userDocument-readonly      true
                                                              :userDocument-rejected      false
                                                              :userDocument-isSelfExplain true
                                                              :userDocument-type          "selfDeclaration"
                                                              }
                                                             (fn []
                                                               (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                                                       {:_selfDeclarationDocument-uuid (:userDocument-uuid document)}
                                                                                                       (fn []
                                                                                                         (d-user/actual-user-invalidate !actual-user)
                                                                                                         (reset! !invalidated true)
                                                                                                         (reset! !show nil)
                                                                                                         )))))
              }
             "Bestätigen"]]

           :else
           [mui/chip {:color "primary" :label (str "Bitte wähle ein Dokument")}]

           )
         ]
        ]]
      )))





(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!show-selfdeclaration-modal !documentHash !show-doc-assign-modal]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!show-selfdeclaration-modal
            documentHash @!documentHash]

        (js/console.log "render selfExplain load modal " tomId documentHash (:reqTomId user))

        (when (and (pos? tomId) (not= tomId (:reqTomId user))) (get-user-details !actual-user tomId))

        (if (or (not= tomId (:reqTomId user)) (:error user))
          ;no data
          [mui/modal
           {:className        "selfexplain-load-modal"
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (if (pos? tomId) true false)
            :onClose          (fn []
                                (reset! !actual-user {})
                                (reset! !show-selfdeclaration-modal nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}
            [:h4 (str "Selbsterklärung bestätigen: " @!show-selfdeclaration-modal)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !show-selfdeclaration-modal nil))
              }
             "Schließen"]
            ]]
          ;has data
          (let [document (first (filter (fn [e] (and (= (:userDocument-uuid e) documentHash))) (:user-userDocument @!actual-user)))]
            [modal !actual-user document !show-selfdeclaration-modal !show-doc-assign-modal]
            )

          )))))